import { Col, Row, Tooltip, Modal } from 'antd';
import { PlusCircleOutlined } from '@ant-design/icons';
import React, { Component } from 'react';
import { SpringGrid } from 'react-stonecutter';
import '../App.css';
import pushBackHome from '../img/pushBackHome_fromMap.svg';
import arrow_scroll_next from '../img/covid19/arrow_scroll_next.svg';
import CML_BipzipSvg from '../img/covid19/cm_bipzip.svg';
import '../style/mapPage.css';
import ArquivoPage_Covid from './ArquivoPage_Covid';
import Card from './Card';
import Map from './map/Map';
import PulseLoader from 'react-spinners/PulseLoader';
import ScaleLoader from 'react-spinners/ScaleLoader';

import Media from 'react-media';
import { SubmitScreen } from './SubmitScreen_hooks';
import { Spring } from 'react-spring/renderprops';

// console.log(
//   '%c Test version.\n Change forumurbano link to real link',
//   'color: #ff0000; font-size: 30px;'
// );

const forumUrbanoLink =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000'
    : 'https://forumurbano.pt';

class MapPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedFreguesia: 'TODOS',
      selectedResposta: null,
      toggleSubmitIcon: false,
      submitModalVisible: false,
      localLoading: false //the other loader is on parent and cant be re used
    };

    this.setSelectedFreguesia = this.setSelectedFreguesia.bind(this);
    this.setSelectedResposta = this.setSelectedResposta.bind(this);
    this.queryResult = this.queryResult.bind(this);
    this.updateListedProjects = this.updateListedProjects.bind(this);

    this.selectFreguesiaFromMap = this.selectFreguesiaFromMap.bind(this);
    this.setSubmitModalVisible = this.setSubmitModalVisible.bind(this);

    this.setIsLoadingLocally = this.setIsLoadingLocally.bind(this);
    this.toggle = this.toggle.bind(this);
    //this.props.setIsLoading(true);
  }

  setIsLoadingLocally(isLoading) {
    this.setState({ localLoading: isLoading });
  }

  setSelectedFreguesia(freguesia) {
    //console.log("Selecting " + freguesia + " on asfsfsfsd");
    this.setState({
      selectedFreguesia: freguesia
    });
  }
  setSubmitModalVisible(submitModalVisible) {
    this.setState({ submitModalVisible });
  }

  selectFreguesiaFromMap = (freguesia) => {
    this.arquivo.selectedFreguesia(freguesia); // do stuff
  };

  setSelectedResposta(resposta) {
    //console.log("Selecting " + freguesia + " on asfsfsfsd");
    this.setState({
      selectedResposta: resposta
    });
  }

  queryResult(result) {
    //console.log(result);
    this.setState({
      queryResult: result
    });
  }

  async componentDidMount() {
    setTimeout(() => this.props.setIsLoading(false), 1000); //0 seconds showing loader - not needed on COVID - stays for later if needed
  }

  updateListedProjects(_filteredProjects) {
    //console.log("called update: " + _filteredProjects);
    //eslint-disable-next-line
    _filteredProjects
      ? this.setState({ filteredProjects: _filteredProjects })
      : null;
  }

  toggle(hover) {
    console.log('changing');
    this.setState({ toggleSubmitIcon: hover });
  }

  renderSubmitForm() {
    return (
      <Modal
        destroyOnClose={true}
        closable={true}
        cancelButtonProps={{ visible: false }}
        title={'Submissão/Edição de Proposta'}
        wrapClassName="vertical-center-modal"
        visible={this.state.submitModalVisible}
        //visible={true}
        okText="Fechar"
        //onOk={() => this.setcovidModalVisible(false)}
        onCancel={() => this.setSubmitModalVisible(false)}
        footer={
          [
            // <Button
            //   key="ok"
            //   onClick={() => this.setCovidModalVisible(false)}
            // >
            //   Fechar
            // </Button>
          ]
        }
        //cancelText={"Imprimir"}
        //onCancel={() => window.print()}
        width="90%"
        zIndex={1009}
        style={{ top: 10 }}
      >
        <SubmitScreen
          setSubmitModalVisible={this.setSubmitModalVisible}
          setIsLoading={this.setIsLoadingLocally}
        />
      </Modal>
    );
  }
  parentLoader() {
    return (
      <div style={{ height: '100vh' }}>
        <div
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
            // marginLeft: "-60px",
          }}
        >
          <PulseLoader
            //className={override}
            sizeUnit={'px'}
            size={60}
            color={'#c81912'}
            loading={this.state.loading}
          />
          <div style={{ fontSize: 22, color: '#999' }}>Fórum Urbano</div>
          <div style={{ fontSize: 17, color: '#999' }}>
            Rede de Apoio Covid 19
          </div>
        </div>
      </div>
    );
  }
  render() {
    //console.log('this.state.filteredProjects', this.state.filteredProjects);
    //console.log('toggleSubmitIcon', this.state.toggleSubmitIcon);
    if (this.props.isLoading) {
      //if (false) {
      //FIXME //re-enable after
      return this.parentLoader();
    } else {
      let scrollAmount = 0;
      return (
        <Media
          queries={{
            small: '(max-width: 599px)',
            medium: '(min-width: 600px) and (max-width: 1199px)',
            large: '(min-width: 1200px)'
          }}
        >
          {(matches) => (
            <div
              style={{
                height: '100vh',
                overflowY: 'scroll',
                scrollbarWidth: 'none'
              }}
            >
              {this.renderSubmitForm()}

              {this.state.localLoading ? this.localLoader() : null}
              <Spring
                from={{ right: -10 }}
                to={{ right: this.state.toggleSubmitIcon ? 0 : -10 }}
                //  toggle={()=>this.toggle()}
              >
                {(props) => (
                  <Tooltip title="Submeta ou edite a sua proposta!">
                    <div
                      onMouseEnter={() => {
                        console.log('enter');
                        this.toggle(true);
                      }}
                      onMouseLeave={() => {
                        console.log('left');
                        this.toggle(false);
                      }}
                      style={{
                        display: 'flex',
                        position: 'absolute',
                        justifyItems: 'flex-start',
                        alignItems: 'center',
                        flexDirection: 'row',
                        bottom: matches.large || matches.medium ? 10 : '50%',
                        right: 0,
                        backgroundColor: '#f77475',
                        width: 100,
                        height: 100,
                        borderTopLeftRadius: '50%',
                        borderBottomLeftRadius: '50%',
                        zIndex: 3000,
                        padding: 20,
                        cursor: 'pointer',
                        ...props
                      }}
                      onClick={() => {
                        this.setSubmitModalVisible(true);
                      }}
                    >
                      <PlusCircleOutlined
                        style={{ fontSize: 60, color: '#000' }}
                      />
                    </div>
                  </Tooltip>
                )}
              </Spring>
              <Row>
                <div
                  style={{
                    width: '100%',
                    height: 10,
                    backgroundColor: '#f77475'
                  }}
                ></div>
                <Col xs={{ span: 0 }} lg={{ span: 1 }}>
                  <div className="goBacktoHomeCOL_fromMap">
                    <a href={forumUrbanoLink}>
                      <img
                        className="pageStickonMap"
                        onClick={this.props.toggleLeft}
                        src={pushBackHome}
                        alt="img"
                      />
                    </a>
                  </div>
                </Col>

                <Col xs={{ span: 24 }} lg={{ span: 17 }}>
                  <Map
                    selectedFreguesia={this.state.selectedFreguesia} //read
                    queryResult={this.state.queryResult}
                    selectFreguesiaFromMap={this.selectFreguesiaFromMap} //write
                    setSelectedFreguesia={this.setSelectedFreguesia}
                  />
                  <div>
                    <img
                      style={{
                        zIndex: '1001',
                        display: 'flex',
                        position: 'absolute',
                        width: 133,
                        height: 48,
                        bottom: matches.large || matches.medium ? 265 : 29,
                        left: 10
                      }}
                      // onClick={() => {
                      //   document.getElementById("scrollable_cards").scrollTo({
                      //     left: Math.max((scrollAmount += 500), 1000),
                      //     behavior: "smooth",
                      //   });
                      // }}
                      src={CML_BipzipSvg}
                      //alt="scroll_next"
                    />
                    <div
                      onClick={() =>
                        window.open('https://perfectorange.pt/', '_blank')
                      }
                      style={{
                        zIndex: '1001',
                        display: 'flex',
                        position: 'absolute',
                        // width: 133,
                        // height: 48,
                        bottom: matches.large || matches.medium ? 249 : 15,
                        left: 10,
                        color: '#000',
                        fontSize: 9,
                        cursor: 'pointer'
                      }}
                    >
                      desenvolvido por: <strong>perfectorange.pt</strong>
                    </div>
                  </div>
                  {(matches.large || matches.medium) && (
                    <div>
                      {/* button slide next */}

                      <img
                        id={'scrollRight'}
                        onMouseEnter={() => {
                          document.getElementById(
                            'scrollRight'
                          ).style.opacity = 1;
                        }}
                        onMouseLeave={() => {
                          document.getElementById(
                            'scrollRight'
                          ).style.opacity = 0.5;
                        }}
                        style={{
                          zIndex: '1009',
                          display: 'flex',
                          position: 'absolute',
                          width: 35,
                          height: 35,
                          bottom: 110,
                          right: 10,
                          opacity: 0.7
                        }}
                        onClick={() => {
                          document.getElementById('scrollable_cards').scrollTo({
                            left: Math.max((scrollAmount += 500), 1000),
                            behavior: 'smooth'
                          });
                        }}
                        src={arrow_scroll_next}
                        alt="scroll_next"
                      />

                      <div
                        id={'scrollable_cards'}
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          flexWrap: 'nowrap',
                          width: '100%',
                          height: '250px',
                          position: 'absolute',
                          overflowX: 'scroll',
                          overflowY: 'hidden',

                          zIndex: '1001',
                          bottom: '0px',
                          backgroundColor: '#ffffffaa'
                        }}
                      >
                        {this.state.filteredProjects
                          ? this.state.filteredProjects
                              .slice(0, 40)
                              .map((proj) => (
                                <Card
                                  selectedResposta={this.state.selectedResposta}
                                  title={proj['Quem sou']}
                                  project={proj}
                                />
                              ))
                          : null}
                      </div>
                    </div>
                  )}
                </Col>

                <Col xs={{ span: 22 }} lg={{ span: 6 }}>
                  <div className="arquivoContainer">
                    <ArquivoPage_Covid
                      setSelectedFreguesia={this.setSelectedFreguesia}
                      setSelectedResposta={this.setSelectedResposta}
                      onRef={(ref) => (this.arquivo = ref)}
                      mapLayout={true}
                      queryResult={this.queryResult}
                      updateListedProjects={this.updateListedProjects}
                      setIsLoading={this.setIsLoadingLocally}
                      isLoading={this.props.isLoading}
                      projectFromDB={this.props.projectFromDB}
                    />
                  </div>
                </Col>
              </Row>
            </div>
          )}
        </Media>
      );
    }
  }

  localLoader() {
    return (
      <div
        style={{
          position: 'fixed',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          width: '100vw',
          zIndex: 3000,
          backgroundColor: '#fff9'
        }}
      >
        <ScaleLoader
          //className={override}
          sizeUnit={'px'}
          size={60}
          color={'#c81912'}
          loading={true}
        />
      </div>
    );
  }
}

export default MapPage;

//export default MapPage;
